<template>
  <div v-if="users">
    <vs-popup :title="$t('LoginLinkTitle')" :active.sync="AfterShare" v-if="AfterShare">
      <div>
        <div class="vx-row">
          <div class="vx-col w-1/1">
            {{ $t('UseThisLinkToSignIn') }}
          </div>
          <div class="vx-col w-1/1">
            <vs-input v-model="loginLink" style=""></vs-input>
            <vs-button color="dark" @click="CopyLink" type="line" style="float:left;" icon-pack="feather" icon="icon-copy" icon-after></vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <div class="flex justify-end">
      <div class="row">
        <vs-input :placeholder="$t('SearchUserPlaceholder')"
                  v-model="searchQuery"
                  class="con-input-search vs-table--search mb-5"
                  icon="icon-search"
                  icon-pack="feather"
                  @keyup.enter="Search()" />

      </div>

      <div>
        <div class="">
          <v-select :placeholder="$t('SortByPlaceholder')"
                    class="ml-5"
                    style="width: 200px"
                    label="label"
                    v-model="sortType"
                    :closeOnSelect="true"
                    @input="SearchWithSort"
                    :reduce="(item) => item.value"
                    :options="sortOptions" />
        </div>
      </div>

      <div>
        <div class="">
          <v-select :placeholder="$t('OrderOfSortPlaceholder')"
                    :key="r_key"
                    class="ml-5"
                    style="width: 200px"
                    label="label"
                    v-model="sortOrder"
                    :closeOnSelect="true"
                    @input="SearchWithSort"
                    :reduce="(item) => item.value"
                    :options="createdSortOptions" />
        </div>
      </div>
    </div>


    <vs-table ref="table" v-model="selection" :data="users" multiple>
      <template slot="thead">
        <vs-th>{{ $t('FullNameHeader') }}</vs-th>
        <vs-th>{{ $t('EmailHeader') }}</vs-th>
        <vs-th>{{ $t('CreatedHeader') }}</vs-th>
        <vs-th>{{ $t('LastLoginHeader') }}</vs-th>
        <vs-th>{{ $t('RoleHeader') }}</vs-th>
        <vs-th>{{ $t('SourceHeader') }}</vs-th>
        <vs-th>{{ $t('ActionsHeader') }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td style="v-align: top; width: 250px; vertical-align: top">
              <vs-avatar :src="tr.avatarUrl" style="bottom:5px; right:5px; display:inline-block; float:left;"
                         color="success"
                         text-color="white"
                         :text="getFriendlyUserName(tr)" />
              <p class="product-name font-medium">
                {{ tr.firstName }} {{ tr.lastName }}
              </p>
            </vs-td>
            <vs-td style="vertical-align: top">
              <p class="product-category" style="max-height: 1.2em; overflow: hidden" v-html="tr.email"></p>
            </vs-td>
            <vs-td style="vertical-align: top">
              <div v-if="tr.created" class="product-category">
                <div v-for="(part, i) in formatDate(tr.created)" :key="i">
                  {{ part }}
                </div>
              </div>
              <p v-else>{{ $t('NotAvailable') }}</p>
            </vs-td>
            <vs-td style="vertical-align: top">
              <div v-if="tr.lastLoginDate" class="product-category">
                <div v-for="(part, i) in formatDate(tr.lastLoginDate)" :key="i">
                  {{ part }}
                </div>
              </div>
              <p v-else>{{ $t('NotAvailable') }}</p>
            </vs-td>
            <vs-td style="v-align: top; vertical-align: top,">
              <vs-chip v-for="role in tr.roles"
                       :key="role.name"
                       color="primary"
                       class="mr-2 mb-1">
                {{ role.name }}
              </vs-chip>
            </vs-td>
            <vs-td style="vertical-align: top">
              <p class="product-category" style="max-height: 1.2em; overflow: hidden" v-html="tr.provider"></p>
            </vs-td>
            <vs-td style="v-align: top; vertical-align: top">
              <vs-dropdown style="cursor: pointer" vs-trigger-click>
                <span style="font-size: 12px">{{ $t('ActionsHeader') }}</span>
                <vs-dropdown-menu>
                  <vs-dropdown-group :vs-label="$t('EditGroup')">
                    <vs-dropdown-item @click.stop="editItem(data[indextr])">{{ $t('EditAction') }}</vs-dropdown-item>
                    <vs-dropdown-item @click.stop="deleteItem(data[indextr],indextr)">{{ $t('DeleteAction') }}</vs-dropdown-item>
                    <vs-dropdown-item @click.stop="sendLoginLink(data[indextr])">{{ $t('SendLoginLinkAction') }}</vs-dropdown-item>
                    <vs-dropdown-item @click.stop="resetPassword(data[indextr])">{{ $t('ResetPasswordAction') }}</vs-dropdown-item>
                  </vs-dropdown-group>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="Math.ceil(totalCount / itemsPerPage)" v-model="currentPage" :max="10" class="mt-5" />
    <UserEditorScreen :userToEdit="currentEditUser" v-on:updated="editUserUpdated" @updateRoles="updateRoles"></UserEditorScreen>
  </div>
</template>
<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';
  import accountsService from "@/accounts/accountsService.js";
  import UserAvatar from "@/views/components/extra-components/users/UserAvatar.vue";
  import UserEditorScreen from "@/views/components/extra-components/users/UserEditorScreen.vue";
  import TagList from "@/views/components/extra-components/taglist/TagList.vue";
  import QRCode from 'qrcode';

  import vSelect from "vue-select";

  export default {
    data() {
      return {
        itemsPerPage: 10,
        selection: [],
        currentEditUser: null,
        AfterShare: false,
        loginLink: null,
        currentPage: 1,
        sortType: '',
        sortOrder:'',
        searchQuery: '',
        r_key:0
      };
    },
    computed: {
      createdSortOptions() {
        return [
          { label: this.$t('AscendingSort'), value: "asc" },
          { label: this.$t('DescendingSort'), value: "desc" }
        ];
      },
      sortOptions() {
        return [
          { label: this.$t('LastLoginDateSort'), value: "lld" },
          { label: this.$t('CreatedSort'), value: "ctd" }
        ];
      }
    },
    mounted() {
    },
    methods: {
      addUser() {
        this.editItem({
          Id: 0,
        });
      },
      Search(evt) {
        if (this.currentPage < 1)
          this.currentPage = 1;

        this.$emit("SearchNeeeded", (this.currentPage - 1) * this.itemsPerPage, this.itemsPerPage, this.searchQuery, this.sortOrder ,this.sortType);
      },

      SearchWithSort() {
        this.$emit("SearchNeeeded", (this.currentPage - 1) * this.itemsPerPage, this.itemsPerPage, "", this.sortOrder,this.sortType);
      },

      editItem(user) {
        this.$set(this, "currentEditUser", user);
      },
      editUserUpdated() {
        this.$set(this, "currentEditUser", null);
      },
      updateRoles(role) {
        this.currentEditUser.roles.push({
          id: role.id,
          name: role.name
        })
      },
      getFriendlyUserName(userNameCandidate) {
        if (userNameCandidate.firstName != null && userNameCandidate.lastName != null && userNameCandidate.lastName.length > 0) {
          let firstNamePart = userNameCandidate.firstName[0];
          let secondNamePart = userNameCandidate.lastName[0];
          firstNamePart.replace(/\b\w/g, char => char.toUpperCase());
          secondNamePart.replace(/\b\w/g, char => char.toUpperCase());
          return firstNamePart + secondNamePart;
        }
        // Remove domain part if '@' is present
        try {
          // Try with Email
          let namePart = userNameCandidate.email.split('@')[0];

          // Replace '.' with ' '
          namePart = namePart.replace(/\./g, ' ');

          // Capitalize first letters
          namePart = namePart.replace(/\b\w/g, char => char.toUpperCase());

          return namePart;
        }
        catch (err) {
        }
        return userNameCandidate.userName;
      },
      loginAsUser(impersonateAs) {
        localStorage.removeItem("userRole");
        localStorage.removeItem(location.hostname + "-userInfo");
        localStorage.removeItem(location.hostname + '-fullUserInfo');

        const payload = {
          checkbox_remember_me: this.checkbox_remember_me,
          userDetails: {
            email: impersonateAs.Email,
            password: null,
            isImpersonating: true,
          },
          notify: this.$vs.notify,
        };

        this.$store.dispatch("auth/loginAttempt", payload);
      },

      removeUserFromRole(userId, roleId, user_index) {
        var instance = this;
        const query = `
          mutation RemoveUserFromRole($roleId: String!, $userId: String!) {
            removeUserFromRole(roleId: $roleId, userId: $userId) {
                id
                name
            }
        }
        `;

        var variables = {
          userId: userId,
          roleId: roleId
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SavedChanges'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.users[user_index].roles.splice(instance.users[user_index].roles.findIndex(item => item.id === roleId), 1);
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ProblemsSavingChanges'));
          }
        });
      },

      formatDate(dateString) {
        const moment = require("moment");
        const m = moment(dateString);
        return [m.format("MMM") + " " + m.format("DD") + " " + m.format("YYYY"), m.format("h:mm:ss a")];
      },

      resetPassword(user) {
        var instance = this;
        if (confirm(instance.$t('ResetPasswordConfirm'))) {
          accountsService.resetPassword(user.email).then(function (response) {
            if (response) {
              instance.$vs.notify({
                title: instance.$t('ResetPassword'),
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                time: 5000,
              });
            }
          }).catch(err => {
            instance.$vs.notify({
              title: instance.$t('ResetPasswordError'),
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
          });
        }
        else {
          return;
        }
      },

      sendLoginLink(user) {
        var instance = this;
        if (confirm(instance.$t('SendLoginLinkConfirm'))) {
          TCVelikClient.PostRelative("/api/accounts/SendLoginLink?ToEmail=" + user.email).then(function (response) {
            if (response) {
              instance.loginLink = response.data.Link;
              instance.AfterShare = true;
              instance.$vs.notify({
                title: instance.$t('LinkSent'),
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                time: 5000,
              });
            }
          }).catch(err => {
            instance.$vs.notify({
              title: instance.$t('SomethingWentWrongSendingLink'),
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
          });
        }
        else {
          return;
        }
      },

      deleteItem(user, index) {
        var instance = this;
        if (confirm(instance.$t('DeleteUserConfirm'))) {
          TCVelikClient.PostRelative("/api/admin/DeleteUser?userId=" + user.id).then(function (response) {
            if (response) {
              instance.$vs.notify({
                title: instance.$t('UserHasBeenDeleted'),
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                time: 5000,
              });
              window.location.reload();
            }
          }).catch(err => {
            instance.$vs.notify({
              title: instance.$t('SomethingWentWrongDeletingUser'),
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
          });
        }
        else {
          return;
        }
      },

      GenerateAPIKey() {
        var instance = this;
      },
      CopyLink() {
        var instance = this;
        this.$copyText(this.loginLink).then(
          function () {
            instance.$vs.notify({
              title: instance.$t('SuccessExclamation'),
              text: instance.$t('TextCopiedSuccessfully'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          })
      }
    },
    props: ["users", "totalCount"],
    watch: {
      'currentPage'(newVal, oldVal) {
        /*alert('Page changed.');*/
        this.$emit("SearchNeeeded", (this.currentPage - 1) * this.itemsPerPage, this.itemsPerPage, this.searchQuery, this.sortOrder, this.sortType);
      },
      'selection'(newVal, oldVal) {
        this.$emit("SelectionChanged", newVal);
      }
    },
    components: {
      UserAvatar,
      UserEditorScreen,
      TagList,
      QRCode,
      vSelect
    },
  };
</script>

